import els from './elements';
import timeline from './timeline';

const prepareAnimation = () => {

    const $text = els.$headingText();
    const $pole = els.$headingPole();
    const $buttons = els.$buttons();

    $text.shrinkWrap();

    gsap.set($pole, { xPercent: -105 });
    gsap.set($pole, { autoAlpha: 1 });

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: $text,
            start: 'center 75%',
        },
    });

    tl.fromTo(
        $text,
        {
            xPercent: -10,
        },
        {
            xPercent: 0,
            autoAlpha: 1,
            ease: 'power2.out',
            duration: 0.75,
        }
    );

    tl.to(
        $pole,
        {
            xPercent: 0,
            ease: 'power3.out',
            duration: 1,
        },
        '<'
    );

    tl.to(
        $buttons,
        {
            autoAlpha: 1,
            ease: 'power3.out',
        },
        '<0.5'
    );
};

const prepareButtons = () => {

    const $prev = els.$prevButton();
    const $next = els.$nextButton();

    $prev.on('click', () => {
        timeline.advance(-1);
    });

    $next.on('click', () => {
        timeline.advance(1);
    });
};

const prepare = () => {
    prepareAnimation();
    prepareButtons();
};

const cleanUp = () => {
    els.$headingText().unshrinkWrap();
    els.$prevButton().off('click');
    els.$nextButton().off('click');
};

export default {
    prepare,
    cleanUp,
};

